import { render, staticRenderFns } from "./PersonalInformation.vue?vue&type=template&id=27a17d38"
import script from "./PersonalInformation.vue?vue&type=script&lang=js"
export * from "./PersonalInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports